import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//国外委员会
function standardListApi() {
  return _standardListApi.apply(this, arguments);
} //GAFW全球
function _standardListApi() {
  _standardListApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", useGet('/web/standardList'));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _standardListApi.apply(this, arguments);
}
function learnApi(_x) {
  return _learnApi.apply(this, arguments);
} //发展历程
function _learnApi() {
  _learnApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(typeId) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", useGet("/web/learnInfo/".concat(typeId)));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _learnApi.apply(this, arguments);
}
function processApi() {
  return _processApi.apply(this, arguments);
}
function _processApi() {
  _processApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", useGet('/web/processLists'));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _processApi.apply(this, arguments);
}
export { standardListApi, learnApi, processApi };